import React, { useContext, useState } from 'react'
import AppContext from '../appContext'
import { bind } from '../wrapper'

interface DeclineDialogProps {
    discard: () => void
    decline: (message: string) => void
}

const DeclineDialog: React.FC<DeclineDialogProps> = (props) => {
    const context = useContext(AppContext)
    const [reason, setReason] = useState('')

    return (
        <div className="m-2">
            <div>{context.word('message')}</div>
            <textarea className="input w-full" {...bind(reason, setReason)}></textarea>
            <div className="flex gap-2 mt-4">
                <div className="btn bg-red-500" onClick={() => props.discard()}>
                    {context.word('discard')}
                </div>
                <div className="btn bg-primary" onClick={() => props.decline(reason)}>
                    {context.word('send')}
                </div>
            </div>
        </div>
    )
}

export default DeclineDialog
